export type Status = "active" | "paused" | "scheduled" | "draft" | "error";

const MAP: Record<Status, { pill: string; dot: string }> = {
	active: { pill: "bg-success-bg text-success-text", dot: "bg-success" },
	paused: { pill: "bg-neutral-100 text-neutral-500", dot: "bg-neutral-400" },
	scheduled: { pill: "bg-info-bg text-info-text", dot: "bg-info" },
	draft: { pill: "bg-neutral-100 text-neutral-500", dot: "bg-neutral-400" },
	error: { pill: "bg-error-bg text-error-text", dot: "bg-error" },
};

export function StatusPill({ status }: { status: Status | string }) {
	const m = MAP[status as Status] ?? MAP.paused;
	return (
		<div
			className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ${m.pill}`}
		>
			<div className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
			{status}
		</div>
	);
}
